var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOutlineLn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.42142 20.1677H1.28014V6.83133H5.42142V20.1677ZM3.34855 5.01213C2.02431 5.01213 0.950195 3.91525 0.950195 2.59098C0.950195 1.95488 1.20288 1.34483 1.65266 0.895044C2.10244 0.445255 2.71247 0.192566 3.34855 0.192566C3.98464 0.192566 4.59467 0.445255 5.04445 0.895044C5.49422 1.34483 5.74691 1.95488 5.74691 2.59098C5.74691 3.91525 4.67235 5.01213 3.34855 5.01213ZM20.9209 20.1677H16.7885V13.6756C16.7885 12.1284 16.7573 10.1442 14.6354 10.1442C12.4823 10.1442 12.1523 11.8252 12.1523 13.5642V20.1677H8.01551V6.83133H11.9874V8.65054H12.0453C12.5982 7.60271 13.9488 6.49692 15.9637 6.49692C20.1549 6.49692 20.9254 9.25694 20.9254 12.8418V20.1677H20.9209Z",
    fill: "#545776"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlineLn);
export default __webpack_public_path__ + "static/media/outline-ln.d6eadce5bbe93d4c817ec19bce40d52d.svg";
export { ForwardRef as ReactComponent };